import LogoWithText from "~/branding/tu/full-text-logo.svg";
import Logo from "~/branding/tu/logo.svg";
import type { TenantDefinition } from "../types";

const tuTenant: TenantDefinition = {
	id: "tu",
	name: "uTranscribe",
	theme: "tu",
	branding: {
		name: "uTranscribe",
		theme: "tu",
		Logo,
		LogoWithText,
	},
};

export default tuTenant;
